module.exports = __webpack_public_path__ + "img/nonprofit-icon.3da520f2.svg";